/**
 * Copyright © 2026 Adnuntius AS.
 */
import {tags as t} from '@lezer/highlight';
import {createTheme} from '@uiw/codemirror-themes';

export const cm5Default = createTheme({
  theme: 'light',
  settings: {
    background: '#ffffff',
    foreground: '#000000',
    caret: '#000000',
    selection: '#d7d4f0',
    selectionMatch: '#d7d4f0',
    gutterBackground: '#f7f7f7',
    gutterForeground: '#999999',
    gutterBorder: '#dddddd',
    lineHighlight: '#e8f2ff'
  },
  styles: [
    {tag: [t.comment, t.lineComment, t.blockComment], color: '#aa5500'},
    {tag: t.keyword, color: '#708090'},
    {tag: [t.atom, t.bool, t.labelName], color: '#221199'},
    {tag: [t.number, t.literal], color: '#116644'},
    {tag: t.definition(t.variableName), color: '#0000ff'},
    {tag: t.local(t.variableName), color: '#0055aa'},
    {tag: [t.typeName, t.namespace], color: '#008855'},
    {tag: [t.string, t.special(t.string), t.deleted], color: '#aa1111'},
    {tag: [t.regexp, t.escape], color: '#ff5500'},
    {tag: [t.meta, t.documentMeta], color: '#555555'},
    {tag: t.special(t.variableName), color: '#3300aa'},
    {tag: [t.angleBracket, t.squareBracket], color: '#997755'},
    {tag: [t.standard(t.tagName), t.tagName], color: '#117700'},
    {tag: [t.attributeName, t.propertyName, t.definition(t.propertyName)], color: '#0000cc'},
    {tag: t.link, color: '#0000cc', textDecoration: 'underline'},
    {tag: [t.heading, t.strong], color: 'blue', fontWeight: 'bold'},
    {tag: t.emphasis, fontStyle: 'italic'},
    {tag: t.strikethrough, textDecoration: 'line-through'},
    {tag: t.invalid, color: '#ff0000'}
  ]
});
